module.exports = "<electra-filter [ngClass]=\"filterClass\" [ngStyle]=\"filterStyle\" (update)=\"gotFilterTop($event)\">\n</electra-filter>\n<electra-legend [ngClass]=\"legendClass\" [ngStyle]=\"legendStyle\" (update)=\"gotLegendTop($event)\">\n</electra-legend>\n<app-iab [ngClass]=\"iabClass\">\n</app-iab>\n<electra-more [ngClass]=\"moreClass\">\n</electra-more>\n<electra-about [ngClass]=\"aboutClass\">\n</electra-about>\n<electra-terms [ngClass]=\"termsClass\">\n</electra-terms>\n<electra-menu [ngClass]=\"menuClass\"></electra-menu>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/menuWrapper/menuWrapper.component.html
// module id = 430
// module chunks = 1